// frontend/src/pages/ResetPasswordPage.jsx
// 重設密碼頁面

import { Container, Box, Typography, Paper } from '@mui/material';
import ResetPassword from '../components/Auth/ResetPassword';

const ResetPasswordPage = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          py: 4,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            borderRadius: 2,
          }}
        >
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Typography
              variant="h4"
              component="h1"
              sx={{
                fontWeight: 'bold',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              BuddhaSearch
            </Typography>
            <Typography variant="subtitle1" color="text.secondary" sx={{ mt: 1 }}>
              佛法搜尋資料庫
            </Typography>
          </Box>
          <ResetPassword />
        </Paper>
      </Box>
    </Container>
  );
};

export default ResetPasswordPage;
